import BaseLineupValidatorBuilder from 'services/sports/default/base-lineup-validator-builder';

export default class EditedLineupValidatorSinglegameBuilder extends BaseLineupValidatorBuilder {
    getInterface({incomingValues = {}}) {
        const {sportConfig, lineupPlayers} = incomingValues;

        return this.getMinTeamsValidator(sportConfig, lineupPlayers);
    }
}
